export default "__VITE_ASSET__pitknIXy__"